import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NavBar from '../shared/navBar';
import Footer from '../shared/footer';
import Sticky from 'react-stickynode';
import MastheadCyoa from './components/masthead-cyoa';
import Infobar from './components/info-bar';
import Details from './components/details';
import Itinerary from './components/itinerary';
import WhyBusabout from './components/why-busabout';
import PriceSummary from './components/price-summary';
import Spinner from '../shared/spinner';
import { FetchIntineraries, PostIntinerariesAccomodation } from '../../actions/itineraries';
import { history } from '../app';
import { FetchErrors } from '../../actions/utils';
import ReactModal from 'react-modal';
import StacklaWidget from './components/stackla-widget';
import { Tooltip } from 'react-tippy';
import Clipboard from 'react-clipboard.js';
import { hasAccomodationChange } from '../../helpers/cyoaHelper';
import { CYOA_NETWORK_IDS } from '../../config';

//React modal set root element
ReactModal.setAppElement('#root');

const queryString = require('query-string');
const qs = queryString.parse(window.location.search);


class Cyao extends PureComponent {

  constructor(props){
    super(props);
    this.state ={
      shareIsOpen:false
    }
    this.openItineraryModal = this.openItineraryModal.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.openCityModal = this.openCityModal.bind(this);
    this.openShareModal = this.openShareModal.bind(this);
    this.closeShareModal = this.closeShareModal.bind(this);
    this.onShareClick = this.onShareClick.bind(this);
  }

  openShareModal(){ this.setState({shareIsOpen:true}); }
  closeShareModal(){ this.setState({shareIsOpen:false}); }
  onShareClick(){ new Clipboard("#linkUrl"); }

  openCityModal(index, name){

    const {
      history
    } = this.props;

    history.push(`${process.env.REACT_APP_ITINERARY_CITY_PAGE}?id=${qs.id}&index=${index}&name=${name}`);

  }
  openItineraryModal(view){

    const {
      history
    } = this.props;

    history.push(`${process.env.REACT_APP_ITINERARY_DETAILS_PAGE}?id=${qs.id}&v=${view === undefined ? 'itinerary' : view  }`);

  }
  openEditModal(){

    const {
      history
    } = this.props;

    history.push(`${process.env.REACT_APP_ITINERARY_EDIT_PAGE}?id=${qs.id}`);
  }


  componentDidMount(){

    const {
      FetchIntineraries,
      itineraries,
      PostIntinerariesAccomodation
    } = this.props;


    //Fetch booking from token or bookingID/email
    if(qs.id !== undefined){
      if(itineraries === undefined) {
        FetchIntineraries(qs.id).then(data => {  

          //Check accommodation radio buttons have been modified
          if(data !== undefined && !hasAccomodationChange(data.sectors)){
            PostIntinerariesAccomodation(data, true, true, (this.props.itineraries.accomm_global_room_type === "none" ? false : true), this.props.itineraries.accomm_global_room_type);
          }  
        });
      }
    }else{
      history.push("/404");
    }

  }


  componentDidUpdate(prevProp, prevState){

    const {
      FetchErrors,
      errorMessages,
      itineraries
    } = this.props;


    if(itineraries !== prevProp.itineraries){

      //Check booking valid - redirect if expired
      if(itineraries.trips.length === 0){
         history.push('/');
      }

      //Fetch error message if not loaded
      if(Object.keys(errorMessages).length === 0) FetchErrors();

    }


  }


  stickyBottomBoundary(){
    if(window.matchMedia("(min-width: 64em)").matches) return "#cyao-itinerary";
    return "#cyao-whybusabout";
  }


  render(){


  const { itineraries }  = this.props;
  const _itineraries = (itineraries !== undefined && Object.keys(itineraries).length > 0) ? itineraries : [];


   if(_itineraries.length === 0){
      return <Spinner text="Loading your adventure..." loadClass="orange-spinner-wrapper" />
    }else{
      return (
        <Fragment>
          <div className="cyoa">
            <NavBar navbar={true}/>
            <MastheadCyoa openItineraryModal={this.openItineraryModal} openShareModal={this.openShareModal}/>
            <Sticky enabled={window.matchMedia("(min-width: 40em)").matches ? true : false} top={0} bottomBoundary={this.stickyBottomBoundary()} innerZ={999998}>
              <Infobar openModal={this.openItineraryModal} openEdit={this.openEditModal} openShareModal={this.openShareModal}/>
            </Sticky>
            <Details openEdit={this.openEditModal} openItineraryModal={this.openItineraryModal} />
            <Itinerary openModal={this.openItineraryModal} openEdit={this.openEditModal} openCity={this.openCityModal}  />
            <WhyBusabout />
            <StacklaWidget />
            <PriceSummary type="itinerary" openModal={this.openItineraryModal} />
            <Footer />
          </div>


          <ReactModal
            className="error-modal share"
            overlayClassName="modal-overlay semi-white scroll"
            isOpen={this.state.shareIsOpen}
            onRequestClose={this.closeShareModal}
            contentLabel="Share modal">
             <div className="error-modal-container">
                <div className="row">
                  <div className="column small-12">
                    <form className="small-12 large-10 small-centered">
                      <h4 className="busabout-h4 no-margin uppercase">Share This Epic Trip</h4>
                      <p>Share the trip link below with your friends and family.</p>

                      <Tooltip title="Copied to clipboard" position="bottom" trigger="click">
                        <div className="share-link" onClick={this.onShareClick}>
                        <Clipboard data-clipboard-text={`${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_PREVIEW_PAGE}?guid=${_itineraries.cyoa_token}&share=1&destination=${_itineraries.trips[0].tour_id === CYOA_NETWORK_IDS["usa"].id ? "usa" : "europe" }`}>
                          <div className="material-input">
                            <label htmlFor="firstName" className="">
                              <span className="link-icon"></span>
                              <input name="linkUrl" id="linkUrl" readOnly className="busbout-input outline" type="text" value={`${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_PREVIEW_PAGE}?guid=${_itineraries.cyoa_token}&share=1&destination=${_itineraries.trips[0].tour_id === CYOA_NETWORK_IDS["usa"].id ? "usa" : "europe"}`} />
                            </label>
                          </div>
                        </Clipboard>
                        </div>
                      </Tooltip>
                    </form>
                  </div>
                </div>

                <button className="close-button" onClick={this.closeShareModal}></button>
             </div>
          </ReactModal>

        </Fragment>
      )
    }

  }
}

function mapStateToProps(state){
  return {
    errorMessages:state.errorMessages,
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchIntineraries,
    FetchErrors,
    PostIntinerariesAccomodation
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Cyao);



// WEBPACK FOOTER //
// ./src/components/itinerary/index.js